import { render, staticRenderFns } from "./AM65LessFading.vue?vue&type=template&id=65e80124&scoped=true"
import script from "./AM65LessFading.vue?vue&type=script&lang=ts"
export * from "./AM65LessFading.vue?vue&type=script&lang=ts"
import style0 from "./AM65LessFading.vue?vue&type=style&index=0&id=65e80124&prod&lang=scss&scoped=true"
import style1 from "./AM65LessFading.vue?vue&type=style&index=1&id=65e80124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e80124",
  null
  
)

export default component.exports